import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { acceptableUsePolicyStyles } from './acceptable-use-policy-helper';
import { BurstSvg } from '../../../assets';
import { Button } from '@biq/apex-ui';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import utf8 from 'utf8';
import { useAuth } from 'core/contexts';
import { useSignAcceptableUsePolicy } from 'hooks';

interface AcceptableUsePolicyProps {
    content: string;
    id: string;
    setIsPolicySigned: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AcceptableUsePolicy = ({
    content,
    id,
    setIsPolicySigned,
}: AcceptableUsePolicyProps): React.JSX.Element => {
    const { logout, getToken } = useAuth();
    const { mutate: signAcceptableUsePolicy } = useSignAcceptableUsePolicy();
    const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);

    const onAcceptPolicyClick = (): void => {
        setIsButtonLoading(true);
        signAcceptableUsePolicy(
            {
                token: getToken(),
                id: id,
            },
            {
                onSuccess: () => {
                    setIsButtonLoading(false);
                    setIsPolicySigned(true);
                },
                onError: () => {
                    setIsButtonLoading(false);
                },
            }
        );
    };

    const onLogoutClick = (): void => {
        logout();
    };

    return (
        <Grid container sx={acceptableUsePolicyStyles.mainContainerStyles}>
            <Grid item sx={acceptableUsePolicyStyles.containerStyles}>
                <Grid sx={acceptableUsePolicyStyles.imageContainer}>
                    <img
                        src={BurstSvg}
                        alt='icon'
                        style={acceptableUsePolicyStyles.imageStyles}
                    />
                </Grid>
                <Grid sx={acceptableUsePolicyStyles.headingContainer}>
                    <Typography sx={acceptableUsePolicyStyles.headingStyles}>
                        Acceptable Use Policy
                    </Typography>
                </Grid>
                <Grid sx={acceptableUsePolicyStyles.contentContainer}>
                    <Typography sx={acceptableUsePolicyStyles.contentStyles}>
                        <Markdown remarkPlugins={[remarkGfm]}>
                            {utf8.decode(atob(content))}
                        </Markdown>
                    </Typography>
                    <Grid sx={acceptableUsePolicyStyles.buttonContainer}>
                        <Button
                            size='large'
                            disabled={isButtonLoading}
                            sx={acceptableUsePolicyStyles.buttonStyles}
                            onClick={onAcceptPolicyClick}
                        >
                            Accept & Continue
                        </Button>
                        <Button
                            size='large'
                            variant='text'
                            sx={acceptableUsePolicyStyles.buttonStyles}
                            onClick={onLogoutClick}
                        >
                            Logout
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
